module.exports = __webpack_public_path__ + "media/components/src/assets/images/block_image_no_image-a9ec599f997a4fdc1ba5e5e140cf1b1f.jpg";